import {
  USER_TOKEN_KEY,
  ZANGIA_TOKEN_KEY_AUTO_LOGIN,
  ZANGIA_TOKEN_KEY,
} from '@/lib/utils/constants';
import { deleteCookie, getCookie, setCookie } from 'cookies-next';

export const AuthTokenStorageService = {
  store(accessToken: string) {
    setCookie(USER_TOKEN_KEY, accessToken, {
      maxAge: 7 * 24 * 60 * 60,
      path: '/',
      domain: process.env.NEXT_PUBLIC_ROOT_DOMAIN || '.zangia.local',
      sameSite: 'lax',
    });
  },

  getAccessToken() {
    const token = getCookie(USER_TOKEN_KEY);
    return typeof token === 'string' && token.length > 0 ? token : undefined;
  },

  clear() {
    deleteCookie(USER_TOKEN_KEY, {
      path: '/',
      domain: process.env.NEXT_PUBLIC_ROOT_DOMAIN || '.zangia.local',
      sameSite: 'lax',
    });
    deleteCookie(ZANGIA_TOKEN_KEY, {
      path: '/',
      domain: process.env.NEXT_PUBLIC_ROOT_DOMAIN || '.zangia.local',
      sameSite: 'lax',
    });
    deleteCookie(ZANGIA_TOKEN_KEY_AUTO_LOGIN, {
      path: '/',
      domain: process.env.NEXT_PUBLIC_ROOT_DOMAIN || '.zangia.local',
      sameSite: 'lax',
    });
  },

  checkIsMobile() {
    return getCookie('isMobile') === 'true';
  },
};
